import { ApiCountry } from "Shared/models/ApiStations";
import { alphabeticalOrderStrategy } from "./alphabeticalOrderStrategy";
import { resourceXmlOrderStrategy } from "./resourceXmlOrderStrategy";
import { useReduxState } from "Shared/redux/useReduxState";

type StationOrder = "FromResourceXml" | "AlphabeticalAsc";

export interface IStationOrderStrategy {
	orderStations: (countries: ApiCountry[]) => ApiCountry[];
	postStep: () => Promise<void>;
}

export const useStationOrderStrategyFactory = (culture: string) => {
	const [navitaireSettings] = useReduxState("navitaireSettings");

	const orderStrategyMap = new Map<StationOrder, () => IStationOrderStrategy>([
		["AlphabeticalAsc", alphabeticalOrderStrategy(navitaireSettings?.abTestSettings)],
		["FromResourceXml", resourceXmlOrderStrategy(navitaireSettings?.stationSettings, culture)],
	]);

	const getStationOrder = (): StationOrder => {
		const alphabeticalAscVariant = navitaireSettings?.abTestSettings?.CorporateSetting.FlightSearchStationOrder;
		const variant = window.JetSmart.Variants.find(
			(v) =>
				v.ExperimentId === alphabeticalAscVariant.ExperimentId &&
				v.VariantKey === alphabeticalAscVariant.Variant
		);
		return variant ? "AlphabeticalAsc" : "FromResourceXml";
	};

	const create = (): (() => IStationOrderStrategy) => {
		const order = getStationOrder();
		return orderStrategyMap.get(order);
	};

	return { create };
};
